import { MessageCircle, Instagram, Youtube, Music2, Download, Phone } from "lucide-react";
import Logo from "@/components/Logo";
import { Reveal } from "@/components/Reveal";
import { WA, SOCIALS, PRICES, DATASHEET, PHONE } from "@/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-brand-ink text-white overflow-hidden grain">
      <div className="absolute inset-0 dotgrid-light opacity-25" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 py-16 lg:py-20">
        <Reveal>
          <div className="grid md:grid-cols-[1.3fr_1fr_1fr] gap-12">
            <div>
              <Logo dark />
              <p className="mt-6 text-slate-400 leading-relaxed max-w-sm">
                Servicio técnico y venta de analizadores de diagnóstico in vitro. Ingeniero biomédico especializado en
                hematología, química, electrolitos y coagulación.
              </p>
              <div className="mt-6 flex items-center gap-3" data-testid="footer-socials">
                {[
                  { icon: Instagram, ...SOCIALS.instagram, testid: "footer-instagram-link" },
                  { icon: Youtube, ...SOCIALS.youtube, testid: "footer-youtube-link" },
                  { icon: Music2, ...SOCIALS.tiktok, testid: "footer-tiktok-link" },
                ].map((s) => (
                  <a
                    key={s.url}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={s.testid}
                    aria-label={s.handle}
                    className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-slate-300 hover:bg-brand-orange hover:border-brand-orange hover:text-white transition-all duration-300"
                  >
                    <s.icon className="h-[18px] w-[18px]" />
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h3 className="font-mono2 text-[11px] uppercase tracking-[0.22em] text-brand-orange">Contacto</h3>
              <ul className="mt-5 space-y-3 text-slate-300">
                <li>
                  <a
                    href={WA.info}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-whatsapp-link"
                    className="inline-flex items-center gap-2.5 font-bold hover:text-brand-orange transition-colors duration-300"
                  >
                    <MessageCircle className="h-4 w-4 text-brand-orange" />
                    WhatsApp 310 432 9342
                  </a>
                </li>
                <li>
                  <a
                    href={PHONE.tel}
                    data-testid="footer-call-link"
                    className="inline-flex items-center gap-2.5 font-bold hover:text-brand-orange transition-colors duration-300"
                  >
                    <Phone className="h-4 w-4 text-brand-orange" />
                    Llamar {PHONE.intl}
                  </a>
                </li>
                <li className="text-sm">Barranquilla, Colombia</li>
                <li className="text-sm">Instagram {SOCIALS.instagram.handle}</li>
                <li className="text-sm">TikTok {SOCIALS.tiktok.handle}</li>
              </ul>
            </div>

            <div>
              <h3 className="font-mono2 text-[11px] uppercase tracking-[0.22em] text-brand-orange">Producto</h3>
              <ul className="mt-5 space-y-3 text-slate-300 text-sm">
                <li>Excbio EH8300 VET · Analizador de hematología</li>
                <li>Precio de lanzamiento: {PRICES.now} {PRICES.iva}</li>
                <li>Garantía de 1 año</li>
                <li>Instalación en tu clínica incluida</li>
                <li>
                  <a
                    href={DATASHEET.url}
                    download={DATASHEET.filename}
                    data-testid="footer-download-datasheet-link"
                    className="inline-flex items-center gap-2 font-bold text-white hover:text-brand-orange transition-colors duration-300"
                  >
                    <Download className="h-4 w-4 text-brand-orange" />
                    {DATASHEET.label}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </Reveal>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            © {new Date().getFullYear()} HAMBURGER INVITRO · Barranquilla, Colombia
          </p>
          <p className="text-xs text-slate-500" data-testid="footer-disclaimer">
            Precios en pesos colombianos, más IVA. Oferta válida hasta agotar existencias.
          </p>
        </div>
      </div>
    </footer>
  );
}
